import { render, staticRenderFns } from "./UpdateCustomerType.vue?vue&type=template&id=bbd9b5cc&scoped=true"
import script from "./UpdateCustomerType.vue?vue&type=script&lang=js"
export * from "./UpdateCustomerType.vue?vue&type=script&lang=js"
import style0 from "./UpdateCustomerType.vue?vue&type=style&index=0&id=bbd9b5cc&prod&scoped=true&lang=css"
import style1 from "./UpdateCustomerType.vue?vue&type=style&index=1&id=bbd9b5cc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbd9b5cc",
  null
  
)

export default component.exports